export default __webpack_public_path__ + "static/spitz-mobile-screens-96aefb22972c725e5951c66d8663f6c3.jpg";